import React, { useState } from 'react';
import styled from "styled-components";
import { Gift, Ticket, Copy } from "lucide-react";

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const Card = styled.div`
  background-color: #292d2e;
  border-radius: 8px;
  padding: 24px;
  border: 1px solid #3a4142;
`;

const CardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
`;

const Title = styled.h2`
  font-size: 20px;
  font-weight: bold;
  color: #fff;
  margin: 0;
`;

const Description = styled.p`
  color: #9ca3af;
  font-size: 14px;
  margin: 0 0 20px 0;
  line-height: 1.6;
`;

const Divider = styled.div`
  height: 1px;
  background-color: #3a4142;
  margin: 20px 0;
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Label = styled.label`
  font-size: 12px;
  font-weight: bold;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

const InputRow = styled.div`
  display: flex;
  gap: 8px;
  
  @media (max-width: 576px) {
    flex-direction: column;
  }
`;

const Input = styled.input`
  flex: 1;
  background-color: #1e2024;
  border: 1px solid #3a4142;
  border-radius: 6px;
  padding: 12px 16px;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  outline: none;
  
  &:focus {
    border-color: #1fc16b;
  }
`;

const ActionButton = styled.button`
  height: 48px;
  padding: 0 24px;
  border-radius: 6px;
  background-color: #1fc16b;
  color: #000;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  font-size: 10px;
  border: none;
  transition: all 0.2s;
  cursor: pointer;

  &:hover {
    background-color: #1ab060;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
  gap: 16px;
  text-align: center;
`;

const EmptyIcon = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background-color: #1e2024;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed #3a4142;
`;

const Offers = () => {
  const [code, setCode] = useState("");

  return (
    <PageContainer>
      <Card>
        <CardHeader>
          <Gift size={24} color="#f59e0b" />
          <Title>Welcome Offer</Title>
        </CardHeader>
        <Description>
          Enter a promotional code to claim your welcome bonus or special rewards.
        </Description>
        <Divider />
        
        <FormGroup>
          <Label>Promo Code</Label>
          <InputRow>
            <Input 
              type="text"
              value={code}
              onChange={(e) => setCode(e.target.value.toUpperCase())}
              placeholder="Enter code here"
            />
            <ActionButton disabled={!code}>Submit Code</ActionButton>
          </InputRow>
        </FormGroup>
      </Card>

      <Card>
        <CardHeader>
          <Ticket size={24} color="#10b981" />
          <Title>Active Offers</Title>
        </CardHeader>
        <Description>
          View your currently active promotional offers and bonuses.
        </Description>
        <Divider />
        
        <EmptyState>
          <EmptyIcon>
            <Ticket size={32} color="#9ca3af" />
          </EmptyIcon>
          <div style={{ color: '#fff', fontWeight: 'bold' }}>No Active Offers</div>
          <div style={{ color: '#9ca3af', fontSize: '14px', maxWidth: '300px' }}>
            You don't have any active offers at the moment. Keep an eye out for special promotions!
          </div>
        </EmptyState>
      </Card>
    </PageContainer>
  );
};

export default Offers;
